import { useDispatch, useSelector } from 'react-redux';
import { getUserCategories, addUserCategory, removeUserCategory } from 'store/categories/actions';
import { getVersion } from 'store/version/actions';
import { resetItemsCategories } from 'store/items-categories/actions';
import { useEffect, useState } from 'react';
import {
  getUserCategories as getUserCategoriesSelector,
  getUserCategoriesLoadingState as getUserCategoriesLoadingStateSelector,
} from 'store/categories/selectors';
import { getUser as getUserSelector } from 'store/users/selectors';
import { getVersion as getVersionSelector } from 'store/version/selectors';
import Info from './info';
import MembershipType from './membership-type';
import Categories from './categories';
import About from './about';
import { Container } from './styles';
import withNavigationFilters from '../../../library/hocs/with-navigation-filters';
import { logout } from '../../../library/auth';

function Settings(props) {
  const dispatch = useDispatch();
  const userCategories = useSelector(getUserCategoriesSelector);
  const userCategoriesLoading = useSelector(getUserCategoriesLoadingStateSelector);
  const user = useSelector(getUserSelector);
  const version = useSelector(getVersionSelector);
  const [localCategories, setLocalCategories] = useState([]);

  useEffect(() => {
    dispatch(getUserCategories());
    dispatch(getVersion());

    return () => {
      dispatch(resetItemsCategories());
    };
  }, []);

  useEffect(() => {
    if (!userCategoriesLoading) {
      setLocalCategories(userCategories.filter(({ active }) => active).map(({ id }) => id));
    }
  }, [userCategoriesLoading]);

  const handleLogout = () => logout(props.history);

  const handleCategoryChange = (id, checked) => {
    const { name } = userCategories.find((category) => id === category.id);
    const newValue = [
      ...(
        checked ? [...localCategories, id] : localCategories.filter((item) => item !== id)
      ),
    ];

    setLocalCategories(newValue);

    if (checked) {
      dispatch(addUserCategory({ id, name }));
    } else {
      dispatch(removeUserCategory({ id, name }));
    }
  };

  if (!user) {
    return null;
  }

  return (
    <Container>
      <Info
        onLogout={handleLogout}
        name={user.name}
        surname={user.surname}
        email={user.email}
      />
      {
        user ? (
          <MembershipType user={user} type={user?.subscription_status_android || user?.subscription_status} />
        ) : null
      }
      <Categories
        data={userCategories}
        selectedData={localCategories}
        onChange={handleCategoryChange}
      />
      <About version={version} itemCount={user.itemCount} syncVersion={user?.data_version} />
    </Container>
  );
}

export default withNavigationFilters(Settings);
